var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.query, size: "small" } },
            [
              _vm.query.packageId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "当前券包" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: { closable: "", type: "success" },
                          on: { close: _vm.clearPackageFilter },
                        },
                        [_vm._v(_vm._s(_vm.currentPackageName))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "券ID" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "请输入CRM券ID", clearable: "" },
                    model: {
                      value: _vm.query.crmCouponId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "crmCouponId", _vm._n($$v))
                      },
                      expression: "query.crmCouponId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "券名称/别名" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "券名称或别名", clearable: "" },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "keyword", $$v)
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.resetSearch } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" }, attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "crmCouponId", label: "CRM券ID", width: "110" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponTitle",
                  label: "券名称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "券别名", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row._editing
                          ? _c("el-input", {
                              staticStyle: { width: "120px" },
                              attrs: { size: "mini" },
                              model: {
                                value: row._alias,
                                callback: function ($$v) {
                                  _vm.$set(row, "_alias", $$v)
                                },
                                expression: "row._alias",
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(row.couponAlias || "-")),
                            ]),
                        _vm._v(" "),
                        row._editing
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "4px" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveAlias(row)
                                  },
                                },
                              },
                              [_vm._v("保存")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    row._editing = true
                                    row._alias = row.couponAlias
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sendNum",
                  label: "发券数量",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.sendNum != null ? row.sendNum + " 张" : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "原价/张", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.oldPrice != null ? row.oldPrice + " 元" : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "券单价", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.rateNum == null
                          ? _c("span", [_vm._v("-")])
                          : row.rateType === 2
                          ? _c("span", [_vm._v(_vm._s(row.rateNum) + " 元")])
                          : _c("span", [_vm._v(_vm._s(row.rateNum) + " %")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "有效期", "min-width": "200", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.formatYxq(row)
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "line-height": "1.5",
                                  color: "#606266",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatYxq(row)) +
                                    "\n            "
                                ),
                                ["0", "2"].includes(String(row.expiryType))
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "4px" } },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.isCouponValid(row)
                                                ? "success"
                                                : "info",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.isCouponValid(row)
                                                    ? "有效"
                                                    : "已过期"
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _c("span", { staticStyle: { color: "#ccc" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "券封面", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.couponImgUrl
                          ? _c("el-image", {
                              staticStyle: {
                                width: "48px",
                                height: "48px",
                                "border-radius": "4px",
                              },
                              attrs: {
                                src: _vm.resPath + row.couponImgUrl,
                                "preview-src-list": [
                                  _vm.resPath + row.couponImgUrl,
                                ],
                                fit: "cover",
                              },
                            })
                          : _c("span", { staticStyle: { color: "#ccc" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "120",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openImgUpload(row)
                              },
                            },
                          },
                          [_vm._v("上传封面")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next",
                  "current-page": _vm.query.page,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.query.limit,
                  total: _vm.total,
                },
                on: {
                  "current-change": function (p) {
                    _vm.query.page = p
                    _vm.fetchList()
                  },
                  "size-change": function (s) {
                    _vm.query.limit = s
                    _vm.query.page = 1
                    _vm.fetchList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传券封面",
            visible: _vm.imgDialog.visible,
            width: "360px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.imgDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _vm.imgDialog.current
                ? _c("el-image", {
                    staticStyle: {
                      width: "120px",
                      height: "120px",
                      "border-radius": "6px",
                      "margin-bottom": "12px",
                    },
                    attrs: {
                      src: _vm.resPath + _vm.imgDialog.current,
                      fit: "cover",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.uploading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.imgInput.click()
                        },
                      },
                    },
                    [_vm._v("选择图片")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "imgInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.handleImgChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }